import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  Entity,
  JoinTable,
  ManyToMany,
  PrimaryGeneratedColumn
} from 'typeorm';
import Categoria from './Categoria';
import Produto from './Produto';

@Entity()
export class Cardapio {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  nome: string = '';

  @ManyToMany(() => Produto)
  @JoinTable({ name: 'cardapio_tem_produtos' })
  produtos!: Produto[];

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;

  categorias: Categoria[] = [];
}

export default Cardapio;
